var map = {
	"./icon-angular.svg": 25,
	"./icon-ar.svg": 5646,
	"./icon-arrow-left-light.svg": 9280,
	"./icon-arrow-left.svg": 9441,
	"./icon-arrow-right-light.svg": 6355,
	"./icon-arrow-right.svg": 9782,
	"./icon-close.svg": 8904,
	"./icon-clutch.svg": 9410,
	"./icon-js.svg": 749,
	"./icon-laravel.svg": 1162,
	"./icon-linkedin.svg": 8571,
	"./icon-list-item.svg": 1325,
	"./icon-node.svg": 2806,
	"./icon-php.svg": 942,
	"./icon-react.svg": 107,
	"./icon-symfony.svg": 3846,
	"./icon-upwork.svg": 3562,
	"./icon-vr.svg": 5976,
	"./icon-webgl.svg": 6147,
	"./icon-yii.svg": 7488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9592;